<template>
  <div>
    <!-- 标题 -->
    <div class="LogManagement-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountTypeName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.logstoreName }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/logManagementMonitor">{{
          $t("alarms.logService.logService")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="LogManagement-top">
      <Row :gutter="16">
        <Col span="6">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col span="6" v-for="(item, index) in list" :key="index">
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
export default {
  name: "LogManagement",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // 折线图
      list: [
        {
          id: "logInflowChart",
          title: this.$t("alarms.logService.line.WriteTrafficByte"),
        },
        {
          id: "logOutflowChart",
          title: this.$t("alarms.logService.line.ReadFlowByte"),
        },
        {
          id: "logMethodQPSChart",
          title: this.$t("alarms.logService.line.NumberOfOperationsCount"),
        },
        {
          id: "netFlowChart",
          title: this.$t("alarms.logService.line.OriginalDataSizeBytes"),
        },
        {
          id: "logCodeQPSChart",
          title: this.$t("alarms.logService.line.ServiceStatusCount"),
        },
        {
          id: "failedLines",
          title: this.$t("alarms.logService.line.FailedLines"),
        },
        {
          id: "sumQps",
          title: this.$t("alarms.logService.line.SumQps"),
        },
        {
          id: "successdByte",
          title: this.$t("alarms.logService.line.SuccessdByte"),
        },
        {
          id: "inflowLine",
          title: this.$t("alarms.logService.line.InflowLine"),
        },
        {
          id: "consumerGroupFallBehind",
          title: this.$t("alarms.logService.line.ConsumerGroupFallBehind"),
        },
      ],
      timeType: 1,
      timeList: [],
      // echarts实例
      chart: "",
      chartLogOutflow: "",
      chartLogMethodQPS: "",
      chartNetFlow: "",
      chartLogCodeQPS: "",
      chartFailedLines: "",
      chartSumQps: "",
      chartSuccessdByte: "",
      chartInflowLine: "",
      chartConsumerGroupFallBehind: "",
      logInflowChartOption: {},
      logOutflowChartOption: {},
      logMethodQPSChartOption: {},
      netFlowChartOption: {},
      logCodeQPSChartOption: {},
      failedLinesOption: {},
      sumQpsOption: {},
      successdByteOption: {},
      inflowLineOption: {},
      consumerGroupFallBehindOption: {},
      // 数组
      logInflow: [],
      logInflowXAxisData: [],
      logOutflow: [],
      logOutflowXAxisData: [],
      logMethodQPS: [],
      logMethodQPSXAxisData: [],
      netFlow: [],
      netFlowXAxisData: [],
      logCodeQPS: [],
      logCodeQPSXAxisData: [],
      failedLinesXAxisData: [],
      sumQpsXAxisData: [],
      successdByteXAxisData: [],
      inflowLineXAxisData: [],
      consumerGroupFallBehindXAxisData: [],
      failedLines: [],
      sumQps: [],
      successdByte: [],
      inflowLine: [],
      consumerGroupFallBehind: [],
    };
  },
  mounted: function () {
    this.queryTimeHorizon();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function () {
      self.chart.resize();
      self.chartLogOutflow.resize();
      self.chartLogMethodQPS.resize();
      self.chartNetFlow.resize();
      self.chartLogCodeQPS.resize();
      self.chartFailedLines.resize();
      self.chartSumQps.resize();
      self.chartSuccessdByte.resize();
      self.chartInflowLine.resize();
      self.chartConsumerGroupFallBehind.resize();
    });
  },
  created() {
    this.dataProcessing();
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "logInflowChart") {
            var optionFll = this.logInflowChartOption;
          } else if (item.id == "logOutflowChart") {
            var optionFll = this.logOutflowChartOption;
          } else if (item.id == "logMethodQPSChart") {
            var optionFll = this.logMethodQPSChartOption;
          } else if (item.id == "netFlowChart") {
            var optionFll = this.netFlowChartOption;
          } else if (item.id == "logCodeQPSChart") {
            var optionFll = this.logCodeQPSChartOption;
          } else if (item.id == "failedLines") {
            var optionFll = this.failedLinesOption;
          } else if (item.id == "sumQps") {
            var optionFll = this.sumQpsOption;
          } else if (item.id == "successdByte") {
            var optionFll = this.successdByteOption;
          } else if (item.id == "inflowLine") {
            var optionFll = this.inflowLineOption;
          } else if (item.id == "consumerGroupFallBehind") {
            var optionFll = this.consumerGroupFallBehindOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    //
    dataProcessing: function () {
      this.$api.log
        .dataProcessing({
          accountId: this.$route.query.accountId,
          timeHorizon: this.timeType,
          monitorModule: 17,
          projectName: this.$route.query.projectName,
          logstoreName: this.$route.query.logstoreName,
          region: this.$route.query.region,
        })
        .then((res) => {
          this.logInflow = res.data.logInflow;
          this.logInflowXAxisData = res.data.logInflowXAxisData;
          this.logOutflow = res.data.logOutflow;
          this.logOutflowXAxisData = res.data.logOutflowXAxisData;
          this.logMethodQPS = res.data.logMethodQPS;
          this.logMethodQPSXAxisData = res.data.logMethodQPSXAxisData;
          this.netFlowXAxisData = res.data.netFlowXAxisData;
          this.netFlow = res.data.netFlow;
          this.logCodeQPSXAxisData = res.data.logCodeQPSXAxisData;
          this.logCodeQPS = res.data.logCodeQPS;
          this.failedLines = res.data.failedLines;
          this.failedLinesXAxisData = res.data.failedLinesXAxisData;
          this.sumQps = res.data.sumQps;
          this.sumQpsXAxisData = res.data.sumQpsXAxisData;
          this.successdByte = res.data.successdByte;
          this.successdByteXAxisData = res.data.successdByteXAxisData;
          (this.inflowLine = res.data.inflowLine),
            (this.inflowLineXAxisData = res.data.inflowLineXAxisData),
            (this.consumerGroupFallBehind = res.data.consumerGroupFallBehind),
            (this.consumerGroupFallBehindXAxisData =
              res.data.consumerGroupFallBehindXAxisData),
            this.init();
        });
    },
    // 切换时间
    changeTimeType: function () {
      this.dataProcessing();
    },
    /******************所有折线图********************************/
    init: function () {
      this.logInflowLine();
      this.logOutflowLine();
      this.logMethodQPSLine();
      this.netFlowLine();
      this.logCodeQPSLine();
      this.failedLines();
      this.sumQpsLine();
      this.successdByteLine();
      this.inflowLine();
      this.consumerGroupFallBehindLine();
    },
    // 写入流量
    logInflowLine: function () {
      this.chart = this.$echarts.init(
        document.getElementById("logInflowChart")
      );
      this.logInflowChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 写入流量
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.WriteTraffic")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.WriteTraffic"),
            type: "line",
            data: this.logInflow,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.logInflowXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chart.setOption(this.logInflowChartOption);
    },
    // 读取流量
    logOutflowLine: function () {
      this.chartLogOutflow = this.$echarts.init(
        document.getElementById("logOutflowChart")
      );
      this.logOutflowChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 读取流量
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.ReadFlow")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.ReadFlow"),
            type: "line",
            data: this.logOutflow,
            itemStyle: {
              normal: {
                color: "#c23531",
                lineStyle: {
                  color: "#c23531",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.logOutflowXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartLogOutflow.setOption(this.logOutflowChartOption);
    },
    // 操作次数
    logMethodQPSLine: function () {
      this.chartLogMethodQPS = this.$echarts.init(
        document.getElementById("logMethodQPSChart")
      );
      this.logMethodQPSChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 操作次数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.NumberOfOperations")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.NumberOfOperations"),
            type: "line",
            data: this.logMethodQPS,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.logMethodQPSXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartLogMethodQPS.setOption(this.logMethodQPSChartOption);
    },
    // 原始数据大小
    netFlowLine: function () {
      this.chartNetFlow = this.$echarts.init(
        document.getElementById("netFlowChart")
      );
      this.netFlowChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 原始数据大小
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.OriginalDataSize")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.OriginalDataSize"),
            type: "line",
            data: this.netFlow,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.netFlowXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartNetFlow.setOption(this.netFlowChartOption);
    },
    // 服务状态
    logCodeQPSLine: function () {
      this.chartLogCodeQPS = this.$echarts.init(
        document.getElementById("logCodeQPSChart")
      );
      this.logCodeQPSChartOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 服务状态
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.ServiceStatus")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.ServiceStatus"),
            type: "line",
            data: this.logCodeQPS,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.logCodeQPSXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartLogCodeQPS.setOption(this.logCodeQPSChartOption);
    },

    // 客户端解析失败行数
    failedLines: function () {
      this.chartFailedLines = this.$echarts.init(
        document.getElementById("failedLines")
      );
      this.failedLinesOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 客户端解析失败行数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.FailedLines")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.FailedLines"),
            type: "line",
            data: this.failedLines,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.failedLinesXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartFailedLines.setOption(this.failedLinesOption);
    },

    //总体QPS
    sumQpsLine: function () {
      this.chartSumQps = this.$echarts.init(document.getElementById("sumQps"));
      this.sumQpsOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 总体QPS
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.SumQps")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.SumQps"),
            type: "line",
            data: this.sumQps,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.sumQpsXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSumQps.setOption(this.sumQpsOption);
    },

    //客户端解析成功流量
    successdByteLine: function () {
      this.chartSuccessdByte = this.$echarts.init(
        document.getElementById("successdByte")
      );
      this.successdByteOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 客户端解析成功流量
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.SuccessdByte")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.SuccessdByte"),
            type: "line",
            data: this.successdByte,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.successdByteXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartSuccessdByte.setOption(this.successdByteOption);
    },

    //写入行数
    inflowLine: function () {
      this.chartInflowLine = this.$echarts.init(
        document.getElementById("inflowLine")
      );
      this.inflowLineOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 写入行数
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.InflowLine")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.InflowLine"),
            type: "line",
            data: this.inflowLine,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.inflowLineXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartInflowLine.setOption(this.inflowLineOption);
    },

    //消费落后时长
    consumerGroupFallBehindLine: function () {
      this.chartConsumerGroupFallBehind = this.$echarts.init(
        document.getElementById("consumerGroupFallBehind")
      );
      this.consumerGroupFallBehindOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // 消费落后时长
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.logService.line.ConsumerGroupFallBehind")],
        },
        series: [
          {
            name: this.$t("alarms.logService.line.ConsumerGroupFallBehind"),
            type: "line",
            data: this.consumerGroupFallBehind,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500",
                },
              },
            },
          },
        ],
        grid: {
          top: "20%",
          left: "3%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.consumerGroupFallBehindXAxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };
      this.chartConsumerGroupFallBehind.setOption(
        this.consumerGroupFallBehindOption
      );
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.projectName = this.$route.query.projectName;
      this.region = this.$route.query.region;
      this.logstoreName = this.$route.query.logstoreName;
      this.accountTypeName = this.$route.query.accountTypeName;
      this.accountName = this.$route.query.accountName;
      this.$router.push({
        path: "/monitor/logManagementDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          projectName: this.projectName,
          logstoreName: this.logstoreName,
          region: this.region,
          accountTypeName: this.accountTypeName,
          accountName: this.accountName,
        },
      });
    },
  },
};
</script>

<style scoped>
.LogManagement-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-6 {
  margin-bottom: 20px;
}
.LogManagement-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>





// WEBPACK FOOTER //
// src/components/monitor/log_management/log_management_dashboard/LogManagement.vue